import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import BatLogo from "@/components/BatLogo";
import { LogOut, Search, Plus } from "lucide-react";

export default function Header({ onAddLink, search, setSearch, stats }) {
  const { user, logout } = useAuth();
  return (
    <header
      className="sticky top-0 z-40 bg-[#0B0E17]/90 backdrop-blur-xl border-b border-slate-800"
      data-testid="app-header"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8 h-20 flex items-center gap-4">
        <div className="flex items-center gap-3" data-testid="brand-logo-batman">
          <span className="text-amber-500 bat-pulse"><BatLogo size={44} /></span>
          <div className="hidden sm:block">
            <div className="font-display uppercase font-extrabold text-xl leading-none text-slate-100">
              Vrax's <span className="text-amber-500">Workflow</span>
            </div>
            <div className="label-mono text-[10px] mt-1">// Gotham Command Deck</div>
          </div>
        </div>

        <div className="flex-1 max-w-md hidden md:block">
          <div className="relative">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
            <input
              placeholder="Search buyer, vendor, url…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="input-tactical w-full pl-9 pr-3 py-2 rounded text-sm"
              data-testid="global-search-input"
            />
          </div>
        </div>

        <div className="hidden lg:flex items-center gap-6 label-mono text-xs" data-testid="header-stats-ticker">
          <span>LINKS <span className="text-amber-400 font-bold">{stats.total}</span></span>
          <span>VALUE <span className="text-emerald-400 font-bold">${stats.value.toFixed(0)}</span></span>
          <span>PENDING <span className="text-yellow-300 font-bold">{stats.pending}</span></span>
        </div>

        <button
          onClick={onAddLink}
          className="btn-signal px-4 py-2 rounded flex items-center gap-2 text-sm"
          data-testid="add-link-header-btn"
        >
          <Plus className="w-4 h-4" /> Add Link
        </button>

        <div className="flex items-center gap-2">
          <div className="hidden sm:block text-right">
            <div className="text-xs text-slate-400 font-mono-vrax">{user?.username || "vrax"}</div>
            <div className="label-mono text-[9px] text-emerald-400">● ONLINE</div>
          </div>
          <button
            onClick={logout}
            className="btn-ghost-tactical p-2 rounded"
            title="Logout"
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      </div>
    </header>
  );
}
